'use client';

import { use } from 'react';
import { resolveText } from '@macaron-a2ui/core/v0_8';
import { MacaronButtonInnerContext, MacaronNumericQuantityLabelContext, MacaronSelectionItemActiveContext } from './scope';
import type { MacaronRenderContext, RecordAny } from '@macaron-a2ui/core/v0_8';

function variantClass(variant?: string): string {
  switch (variant) {
    case 'title':
      return 'font-sans text-[20px] font-semibold leading-[1.25]';
    case 'bodySemibold':
      return 'font-sans text-[16px] font-semibold leading-[1.63]';
    case 'bodySans':
      return 'font-sans text-[16px] font-normal leading-[1.63]';
    case 'bodySansSemibold':
      return 'font-sans text-[16px] font-semibold leading-[1.63]';
    case 'subheadline':
      return 'font-sans text-[14px] font-normal leading-[1.86]';
    case 'subheadlineSemibold':
      return 'font-sans text-[14px] font-semibold leading-[1.86]';
    case 'caption':
      return 'font-sans text-[12px] font-normal leading-[1.5]';
    case 'captionSemibold':
      return 'font-sans text-[12px] font-semibold leading-[1.5]';
    default:
      return 'font-sans text-[16px] font-normal leading-[1.63]';
  }
}

function colorClass(color?: string): string {
  switch (color) {
    case 'secondary':
      return 'text-[#595856]';
    case 'tertiary':
      return 'text-[#ABAAA6]';
    default:
      return 'text-[#161615]';
  }
}

function formatNumericQuantity(text: string, shouldPrefix: boolean): string {
  if (!shouldPrefix) return text;
  const trimmed = text.trim();
  return /^\d+$/.test(trimmed) ? `×${trimmed}` : text;
}

export function MacaronLabel({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const text = resolveText(config.text, ctx.data);
  const variant = typeof config.variant === 'string' ? config.variant : '';
  const color = typeof config.color === 'string' ? config.color : undefined;
  const inButton = use(MacaronButtonInnerContext);
  const inSelectedItem = use(MacaronSelectionItemActiveContext);
  const shouldPrefixNumericQuantity = use(MacaronNumericQuantityLabelContext);
  const displayText = formatNumericQuantity(text, shouldPrefixNumericQuantity);
  return <div className={`${variantClass(variant)} ${inSelectedItem ? 'text-[#8CA62A]' : colorClass(color)} ${inButton ? '' : 'whitespace-pre-line'}`}>{displayText}</div>;
}
